"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var de_DE_json_1 = __importDefault(require("./de-DE.json"));
var en_US_json_1 = __importDefault(require("./en-US.json"));
var es_ES_json_1 = __importDefault(require("./es-ES.json"));
var ru_RU_json_1 = __importDefault(require("./ru-RU.json"));
var it_IT_json_1 = __importDefault(require("./it-IT.json"));
var pt_PT_json_1 = __importDefault(require("./pt-PT.json"));
var fr_FR_json_1 = __importDefault(require("./fr-FR.json"));
var pl_PL_json_1 = __importDefault(require("./pl-PL.json"));
var tr_TR_json_1 = __importDefault(require("./tr-TR.json"));
var sv_SE_json_1 = __importDefault(require("./sv-SE.json"));
var uk_UA_json_1 = __importDefault(require("./uk-UA.json"));
var ro_RO_json_1 = __importDefault(require("./ro-RO.json"));
var no_NO_json_1 = __importDefault(require("./no-NO.json"));
var nl_NL_json_1 = __importDefault(require("./nl-NL.json"));
var hu_HU_json_1 = __importDefault(require("./hu-HU.json"));
var hr_HR_json_1 = __importDefault(require("./hr-HR.json"));
var fi_FI_json_1 = __importDefault(require("./fi-FI.json"));
var el_GR_json_1 = __importDefault(require("./el-GR.json"));
var cs_CZ_json_1 = __importDefault(require("./cs-CZ.json"));
var da_DK_json_1 = __importDefault(require("./da-DK.json"));
var resources = {
    de: Object.assign(de_DE_json_1.default),
    en: Object.assign(en_US_json_1.default),
    es: Object.assign(es_ES_json_1.default),
    fr: Object.assign(fr_FR_json_1.default),
    it: Object.assign(it_IT_json_1.default),
    pt: Object.assign(pt_PT_json_1.default),
    ru: Object.assign(ru_RU_json_1.default),
    pl: Object.assign(pl_PL_json_1.default),
    tr: Object.assign(tr_TR_json_1.default),
    sv: Object.assign(sv_SE_json_1.default),
    uk: Object.assign(uk_UA_json_1.default),
    ro: Object.assign(ro_RO_json_1.default),
    no: Object.assign(no_NO_json_1.default),
    nl: Object.assign(nl_NL_json_1.default),
    hu: Object.assign(hu_HU_json_1.default),
    hr: Object.assign(hr_HR_json_1.default),
    fi: Object.assign(fi_FI_json_1.default),
    el: Object.assign(el_GR_json_1.default),
    cs: Object.assign(cs_CZ_json_1.default),
    da: Object.assign(da_DK_json_1.default),
};
exports.default = resources;
